// 设置接口 
import axios from 'axios'

// 局域网打印机列表
export function getPrintList() {
  return axios({
    url: `/api/setup/printList`,
    method: 'get',
  })
}
// 通过打印类型获取当前打印的打印机名称printFactoryId,printType
export function printByType(data) {
  return axios({
    url: `/api/setup/printByType?`,
    method: 'get',
    params: data
  })
}
// 新增默认打印机
export function insertPrint(data) {
  return axios({
    url: `/api/setup/printInsert`,
    method: 'post',
    data
  })
}
// 修改默认打印机
export function updatePrint(data) {
  return axios({
    url: `/api/setup/printUpdate`,
    method: 'post',
    data
  })
}

// 格架号列表
export function grillageListPage(data) {
  return axios({
    url: `/api/setup/grillageListPage`,
    method: 'get',
    params: data
  })
}
// 删除格架号
export function deleteGrillage(id) {
  return axios({
    url: `/api/setup/grillageDelete?id=${id}`,
    method: 'get'
  })
}
// 新增格架号
export function insertGrillage(data) {
  return axios({
    url: `/api/setup/grillageInsert`,
    method: 'post',
    data
  })
}
// 修改格架号
export function updateGrillage(data) {
  return axios({
    url: `/api/setup/grillageUpdate`,
    method: 'post',
    data
  })
}
// 返回有效格架号
export function effectiveGrillage() {
  return axios({
    url: `/api/setup/effectiveGrillage`,
    method: 'get',
  })
}
// 线上——返回附件有效格架号
export function effectiveGrillageFJ() {
  return axios({
    url: `/api/setup/effectiveFJGrillage`,
    method: 'get',
  })
}

// 门店-返回有效格架号
export function effectiveGrillageMD() {
  return axios({
    url: `/api/setup/effectiveMDGrillage`,
    method: 'get',
  })
}

// 门店——返回附件有效格架号
export function effectiveGrillageFJMD() {
  return axios({
    url: `/api/setup/effectiveMDFJGrillage`,
    method: 'get',
  })
}
// 工厂关联列表(分页)
export function factorySetupList(data) {
  return axios({
    url: `/api/setup/factorySetupListPage`,
    method: 'get',
    params: data
  })
}

//工厂关联删除
export function factorySetupDelete(id) {
  return axios({
    url: `/api/setup/factorySetupDelete?id=${id}`,
    method: 'get',
  })
}

// 工厂关联新增
export function factorySetupInsert(data) {
  return axios({
    url: `/api/setup/factorySetupInsert`,
    method: 'post',
    data
  })
}

// 工厂关联修改
export function factorySetupUpdate(data) {
  return axios({
    url: `/api/setup/factorySetupUpdate`,
    method: 'post',
    data
  })
}

// 地区列表
export function adminAreaList() {
  return axios({
    url: `/api/setup/adminAreaList`,
    method: 'get',
  })
}

// 修改密码password,username
export function updatePassword(data) {
  return axios({
    url: `/api/ums/user/updatePassword`,
    method: 'post',
    params: data
  })
}

// 物流设置分页列表
export function setUpExpress(data) {
  return axios({
    url: `/api/pms/expressSetup/listPage`,
    method: 'get',
    params: data
  })
}

// 查询物流设置寄出寄回
export function queryExpress(expressStatus) {
  return axios({
    url: `/api/pms/expressSetup/expressSetup?expressStatus=${expressStatus}`,
    method: 'get'
  })
}

// 新增物流设置
export function insertSetExpress(data) {
  return axios({
    url: `/api/pms/expressSetup/insert`,
    method: 'post',
    data
  })
}
// 修改物流设置
export function updateSetExpress(data) {
  return axios({
    url: `/api/pms/expressSetup/update`,
    method: 'post',
    data
  })
}

// 删除包邮设置
export function deleteFree(id) {
  return axios({
    url: `/api/pms/expressFreeShipping/delete?id=${id}`,
    method: 'get'
  })
}

// 新增包邮设置
export function insertFree(data) {
  return axios({
    url: `/api/pms/expressFreeShipping/insert`,
    method: 'post',
    data
  })
}

// 查询包邮设置(不分页)
export function getFreeList(data) {
  return axios({
    url: `/api/pms/expressFreeShipping/list`,
    method: 'get',
    params: data
  })
}

// 查询包邮设置(分页)
export function getFreeAll(data) {
  return axios({
    url: `/api/pms/expressFreeShipping/listPage`,
    method: 'get',
    params: data
  })
}

// 修改包邮设置
export function updateFree(data) {
  return axios({
    url: `/api/pms/expressFreeShipping/update`,
    method: 'post',
    data
  })
}

